import React, { useEffect, } from 'react'
import { Modal } from 'react-bootstrap';
import axios from 'axios';

import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, buttonProcessGet, languageObjGet, isUndNullEmp, awaitDelay, } from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { userModelGet } from '../../models/users/user';

const currentMethod = 'AparmentUserAdd';

const { app, html, images, labels, messages, } = globalSettings;
const { backend, } = app;

export default function AparmentUserAdd({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    apartment = apartmentModelGet({}),
    apartmentUsers = [apartmentUserModelGet({})],
    dtId = '',
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let header = {};
    let dataObj = {};
    let usersChecked = [];
    const dtUsersId = 'users';
    let users = [userModelGet({})];
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnModalApartmentuserAddSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnModalApartmentuserAddBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalApartmentuserAddClose',
            },
        },
        checkBox: {
            // topLevel: {
            //     id: 'chkTopLevel',
            //     className: 'icheck-primary',
            // },
            // lowLevel: {
            //     id: 'chkLowLevel',
            //     className: 'icheck-primary',
            // }
        },
        dataTables: {
            users: {
                // buttons: {
                //     add: {
                //         id: 'btnUsersAdd',
                //         className: 'btn btn-outline-success float-right btn-sm',
                //     },
                // },
                // icons: {
                //     add: {
                //         id: 'icoUsersAdd',
                //         className: globalSettings?.icons?.plusCircle,
                //     },
                // },
                inputs: {
                    search: {
                        id: `${dtUsersId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtUsersId}_length select`,
                        className: '',
                    },
                },
                // spinners: {
                //     add: {
                //         id: 'spUsersAdd',
                //         className: '',
                //     },
                // },
            },
            // apartmentPeoples: {
            //     buttons: {
            //         add: {
            //             id: 'btnApartmentPeoplesAdd',
            //             className: 'btn btn-outline-success float-right btn-sm',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icoApartmentPeoplesAdd',
            //             className: globalSettings?.icons?.plusCircle,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtApartmentPeoplesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtApartmentPeoplesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spApartmentPeoplesAdd',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'iconModalApartmentuserAddSave',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'iconModalApartmentuserAddBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        inputs: {
            // identifier: {
            //     id: 'inputIdentifier',
            //     className: 'form-control',
            // },
            // aliquot: {
            //     id: 'inputAliquot',
            //     className: 'form-control text-right',
            // },
            // parkingStalls: {
            //     id: 'inputParkingStalls',
            //     className: 'form-control',
            // },
            // phoneNumber: {
            //     id: 'inputPhoneNumber',
            //     className: 'form-control',
            // },
        },
        selects: {
            // floor: {
            //     id: 'selFloor',
            //     className: 'form-select',
            // },
        },
        spinners: {
            save: {
                id: 'spModalApartmentuserAddSave',
                className: '',
            },
            back: {
                id: 'spModalApartmentuserAddBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }
            setShowModal(!isModalClose);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region checkBox set
            users = [];
            apartmentUsers?.forEach((detail) => {
                let checkBoxHtml = `<div class='custom-control custom-checkbox'>`;
                checkBoxHtml += `  <input class='custom-control-input' type='checkbox' email='${detail?.email}' firstName='${detail?.firstName}' lastName='${detail?.lastName}' id='${detail?.id}' value='${detail?.id}'>`;
                checkBoxHtml += `      <label for='${detail?.id}' class='custom-control-label'></label> `;
                checkBoxHtml += `</div> `;
                users?.push([
                    !isUndNullEmp({ data: detail?.firstName, subMethod: currentMethod, })?.result &&
                        !isUndNullEmp({ data: detail?.lastName, subMethod: currentMethod, })?.result ? `${detail?.firstName}, ${detail?.lastName}` : detail?.firstName,
                    detail?.email,
                    checkBoxHtml,
                ]);
            });
            //#endregion checkBox set

            //#region dataTable set
            response = dataTableUsersSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set

            //#region queryCode sey
            response = queryCodeSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion queryCode sey

            $(`#${dtUsersId}`)?.DataTable()?.rows?.add(users)?.draw(true);
        } catch (ex) {
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTableUsersSet = ({ subMethod = '', }) => {
        let response = responseGet();
        try {
            $(`#${dtUsersId}`)?.DataTable({
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '50%', },
                    { title: labels?.email?.[languageObj?.id], width: '45%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let email = '';
            let rowIndex = 0;
            let firstName = '';
            let lastName = '';
            let isChecked = false;
            //#endregion variables

            //#region Dt users
            $(`#${dtUsersId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                rowIndex = $(`#${dtUsersId}`)?.DataTable()?.row(this)?.index();
                if (!isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    email = e?.target?.attributes?.email?.value || '';
                    firstName = e?.target?.attributes?.firstName?.value || '';
                    lastName = e?.target?.attributes?.lastName?.value || '';
                    isChecked = e?.target?.checked || false;
                    if (!isUndNullEmp({ data: id, subMethod: currentMethod, })?.result) {
                        switch (isChecked) {
                            case true:
                                usersChecked?.push({ id: id, email: email, firstName: firstName, lastName: lastName, })
                                break;
                            default:
                                usersChecked = usersChecked?.filter(({ id: idLocal }) => idLocal !== id);
                                break;
                        }
                    }
                }
            });
            //#endregion Dt users
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const apartmentUsersPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'apartmentUsersPostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let userCheckedDataLocal = [];
            let apartmentUsersLocal = [apartmentUserModelGet({})];
            //#endregion variables

            //#region check usersCheck
            if (usersChecked?.length <= 0) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectRecord?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion check usersCheck

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            apartmentUsersLocal = [];
            usersChecked?.forEach((detail) => {
                apartmentUsersLocal?.push(
                    apartmentUserModelGet({
                        buildingId: apartment?.buildingId,
                        apartmentId: apartment?.id,
                        userId: detail?.id,
                        createdUserId: auth?.user?.uid,
                    })
                );
            });

            dataObj = {
                apartmentUsers: apartmentUsersLocal,
                conditionals: [],
                ordersBy: [],
                method: backend?.methods?.apartmentUsers?.listCreateAsync,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentUsers}/`,
            };

            header = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                header,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion data save

            //#region dtApartmentUsers data set
            apartmentUsersLocal = response.result;
            apartmentUsersLocal = apartmentUsersLocal?.filter(({ isNew, }) => isNew);
            if (!isUndNullEmp({ data: apartmentUsersLocal, subMethod: currentMethod, })?.result && apartmentUsersLocal?.length > 0) {
                apartmentUsersLocal?.forEach((detail) => {
                    userCheckedDataLocal = usersChecked?.filter(({ id, }) => id === detail?.userId);
                    if (!isUndNullEmp({ data: userCheckedDataLocal, subMethod: currentMethod, })?.result && userCheckedDataLocal?.length > 0) {
                        $(`#${dtId}`)?.DataTable()?.row?.add([
                            userCheckedDataLocal?.[0]?.firstName,
                            userCheckedDataLocal?.[0]?.lastName,
                            userCheckedDataLocal?.[0]?.email,
                            buttonProcessGet({
                                id: detail?.id,
                                description: `${userCheckedDataLocal?.[0]?.firstName}, ${userCheckedDataLocal?.[0]?.lastName}`,
                                showDetails: false,
                                labelDetails: labels?.detail?.[languageObj?.id],
                                enabledDetails: false,
                                showEdit: false,
                                labelEdit: labels?.edit?.[languageObj?.id],
                                enabledEdit: false,
                                showDelete: true,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: true,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ])?.draw(true);
                    }
                });
            }
            //#endregion dtApartmentUsers data set

            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.buttons?.close?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save?.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.buttons?.close?.id}`)?.addClass(controls?.buttons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.selects?.floor?.id}`).attr('disabled', (processType !== 0));
            // $(`#${controls?.inputs?.identifier?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.aliquot?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.parkingStalls?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.phoneNumber?.id}`).attr('readOnly', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTables
            $(`#${controls?.dataTables?.users?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.users?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTables

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} scrollable={false} onHide={() => setShowModal(false)} >
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.owner?.[languageObj?.id]}
                        src={images?.keyHouse}
                        style={styles?.cardHeaderLogo}></img> - {labels?.owner?.[languageObj?.id]} / {labels?.tenant?.[languageObj?.id]} ({labels?.add?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnHeader', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => apartmentUsersPostAsync({ e: e, subMethod: currentMethod, })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => apartmentUsersPostAsync(e)}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.owner?.[languageObj?.id]} src={images?.keyHouse} style={styles?.cardHeaderLogo}></img> - {labels?.owner?.[languageObj?.id]} / {labels?.tenant?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* Body */}
                    {/* <div className='card-body'> */}
                    {/*Partment users*/}
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className={html?.dataTables?.formats?.tableResponsiveSm}>
                                <table id={dtUsersId} className={html?.dataTables?.formats?.smStripedBordered}></table>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                                <div className='form-group text-right'>
                                    <button id={controls?.buttons?.save?.id}
                                        className={controls?.buttons?.save?.className}
                                        tooltip='tooltip'
                                        title={labels?.add?.[languageObj?.id]}
                                        type='submit'>
                                        <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                    </button>
                                    <button id={controls?.buttons?.back?.id}
                                        className={controls?.buttons?.back?.className}
                                        tooltip='tooltip'
                                        title={labels?.close?.[languageObj?.id]}
                                        type='reset'
                                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnFooter', })}>
                                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                    </button>
                                </div>
                            </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            tooltip='tooltip'
                            title={labels?.add?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnFooter', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}